import React from "react";
import "./sidebar-menu.styles.css"

export default function SidebarMenu() {
    return (
        <div className="ui vertical inverted sidebar sh-siderbar blue menu">
            <div className="item">
                <div className="header">
                    <img id="sidebarMenuImage" src="https://static.cctech.co.in/prod/images/common/cctech-logo/CCTech-Research-Logo-Letters-White.svg" alt="CCTech Research Logo"></img>
                </div>
                <div className="menu">
                    <a className="item sidebarLink" href="https://www.cctech.co.in/research#areas">Research areas</a>
                    <a className="item sidebarLink" href="https://experiments-dev.cctech.co.in">Projects</a>
                    {/* <a className="item sidebarLink" href="https://www.cctech.co.in/research/research-people">People</a> */}
                    <a className="item sidebarLink" href="https://www.cctech.co.in/careers">Careers</a>
                    {/* <a className="item sidebarLink" href="https://www.cctech.co.in/blog/category/Research">Blog</a> */}
                </div>
            </div>
            <div className="ui divider dashed white no-margin"></div>
            <div className="item text white" id="sidebarMenuTitle">
                Centre for Computational Technologies Pvt. Ltd.
            </div>
        </div>
    )
}